<template>
  <div class="documents-list">
    <h4><i class="fa fa-file-text"></i>Documents administratifs</h4>
    <h5 class="text-danger">Les documents apparaissant dans cette rubrique sont visibles et accessibles par le client, depuis son espace.</h5>
    <hr>
    <div style="background-color: #eaeaea; padding: 5px 15px 15px; margin-bottom: 20px; border-radius: 5px;">
      <h5>Procédure à suivre :</h5>
      
      <ol class="instructions">
        <li>Créer un dossier portant le nom du prospect/cient sur votre poste de travail</li>
        <li>
          Vérifier/signer/scanner les fichiers de chaque document et :
          <ol class="instructions">
            <li>Valider le document lorsque tout semble correct</li>
            <li>Supprimer le(s) fichier(s) incorrects, refuser le document en attente de validation et prévenir le client par email de la raison du refus</li>
          </ol>
        </li>
        <li>Une fois le document validé, télécharger les fichiers dans le dossier correspondant sur votre poste de travail</li>
        <li>
          Une fois le client descendu dans SAP, charger le contenu du dossier prospect/client 
          de votre poste de travail dans la <a href="http://ged.sofradom.local" target="_blank">GED</a>.
        </li>
      </ol>
    </div>

    <documents-list v-if="currentDemand"
      :customer-id="currentDemand.customer_id"
      :validation-request-id="currentDemand.id"
    ></documents-list>
  </div>
</template>

<script>
  import { mapActions, mapState } from "vuex"
  import DocumentsList from './Documents/List'

  export default {
    name: "Step3",

    data () {
      return {
      }
    },

    components: {
      DocumentsList
    },

    computed: {
      ...mapState('demands', ['forms', 'demands', 'current_demands']),

      currentDemand() {
        return _.find(this.current_demands, (demand) => demand.id == this.$route.params.id)
      }
    }
  }

</script>

<style lang="scss" scoped>
.documents-list {
  h5 {
    font-weight: bold;
  }
  
  ol.instructions {
    margin-bottom: 0;
    padding-left: 25px;
    counter-reset: item;

    & > li {
      display: block;

      &:before {
        content: counters(item, ".") ". "; 
        counter-increment: item;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// client/components/Demands/Step3.vue